import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useUpdateRetainedEarnings = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, data.currentStatusName);

  return useApiMutation({
    url: `/orders/${orderId}/retained-earnings`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar pedido',
    successTitle: 'Pedido atualizado com sucesso',
    successMessage: 'Dinheiro com a empresa foi alterado com sucesso!',
    onSuccess,
  });
};

export default useUpdateRetainedEarnings;
